/**
 * @description Tracks whether a director walked through the organization
 * onboarding, including when every step was skipped and therefore no
 * graduation class exists to infer completion from.
 */
const ONBOARDING_DISMISSED_KEY_PREFIX = "vetnebula:onboarding-dismissed:";

const storageKey = (orgId: string) =>
  `${ONBOARDING_DISMISSED_KEY_PREFIX}${orgId}`;

export const isOnboardingDismissed = (orgId?: string | null): boolean => {
  if (!orgId) {
    return false;
  }
  return window.localStorage.getItem(storageKey(orgId)) === "true";
};

export const dismissOnboarding = (orgId?: string | null): void => {
  if (!orgId) {
    return;
  }
  window.localStorage.setItem(storageKey(orgId), "true");
};
